import './go-back.scss';

const GoBackComponent = {
  el: null,

  init() {
    this.els = document.querySelectorAll('[go-back]');
    this.els.forEach((btn) => {
      btn.addEventListener('click', this.handleClick.bind(this));
    });
  },

  handleClick() {
    window.history.back();
  }
};

export default GoBackComponent;